import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useHref } from 'src/hooks/useHref';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import { ROUTES } from 'src/constants/routes.const';
import { TagPageProps } from '../types/tagPageProps';
import * as localesWithMessages from './messages';
import * as S from './styles';

type MoviesJumbotronProps = Pick<TagPageProps, 'tag'>;

export const MoviesJumbotron = ({ tag }: MoviesJumbotronProps) => {
  const intl = useIntl();

  const tagHref = useHref({
    pathname: ROUTES.tag,
    query: { tagNameSlug: tag.localizedNameSlug },
  });

  const targetMsgs = useTargetMessages(localesWithMessages);

  const breadcrumbs = useMemo(
    () => [{ name: tag.localizedName, url: tagHref }],
    [tag.localizedName, tagHref],
  );

  return (
    <S.MoviesJumbotron data-testid="moviesJumbotron">
      <S.Backdrop>
        <S.LanguagePairBreadcrumbs breadcrumbs={breadcrumbs} inverse />

        <S.PositioningContainer>
          <S.Title>{intl.formatMessage(targetMsgs.title)}</S.Title>

          <S.Description>{intl.formatMessage(targetMsgs.description)}</S.Description>

          <S.MemriseTeamBanner />
        </S.PositioningContainer>
      </S.Backdrop>
    </S.MoviesJumbotron>
  );
};
